import React, { useEffect } from 'react';
import { Title } from '../../ui/Title';
import { ScrollY } from '../../layout/Scroll/ScrollY';

import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { IProject } from '../../../interface/interfaces';
import { fetchProjectDataPending } from './projects.slice';
import { Loader } from '../../shared/Loader/Loader';
import { Full } from '../../layout/Full/Full';
import { RelativeCenter } from '../../layout/RelativeCenter/RelativeCenter';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { ErrorNotification } from '../../shared/ErrorNotification/ErrorNotification';
import { ExecButton } from '../../ui/ExecButton/ExecButton';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { ProjectNode } from './ProjectNode';
import { useTranslation } from 'react-i18next';
import { ToolTipWrapper } from '../../layout/ToolTipWrapper/ToolTipWrapper';
import { removeAllPaths } from '../UserSettings/FilePath/userSettingsFilePathFastChanging.slice';
import { PROJECT_ADMIN, ROUTES } from '../../../constants/constants';
import { SpacingCustom } from '../../layout/Spacing/SpacingCustom';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { ProtectedUsers } from '../../shared/ProtectedUsers/ProtectedUsers';
import { fetchUserSettingsProjectPathFailure } from '../UserSettings/ProjectPath/userSettingsProjectPath.slice';
import { removeProjectPath } from '../UserSettings/ProjectPath/userSettingsProjectPathFastChanging.slice';

export const Projects = () => {
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);
    const {savedUserToken} = useAppSelector((state: rootState) => state.savedUserToken);
    const { projectError, projectsData, projectsLoading } = useAppSelector((state: rootState) => state.projects);
    const { project } = useAppSelector((state: rootState) => state.project);
    const {hostnameAndUsername} = useAppSelector((state:rootState)=>state.hostAndUsername)

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();


    useEffect(()=>{
        dispatch(removeAllPaths());
    },[dispatch])


    useEffect(() => {
        if (userAndTokenData) {
            dispatch(fetchProjectDataPending({
                url: 'Projects', 
                token: userAndTokenData.token
            }));
        }
    }, [dispatch, userAndTokenData]);

    useEffect(() => {
        if (projectError) {
            toast.error(projectError);
        }
    }, [projectError]);

    const onSubmit = ()=>{

        navigate(`/${ROUTES.CONFIGURATION}/${project?._id}/${ROUTES.DASHBOARD}`);
    }

    useEffect(()=>{
        dispatch(fetchUserSettingsProjectPathFailure(''))
        dispatch(removeProjectPath())
    },[dispatch])

    const createProjectButtons = projectsData.map((item: IProject, idx: number) => {
        return(
            <FlexCenter key={idx} direction='v' position='start' stretch >

                <ToolTipWrapper
                    
                    toolTipContent={{
                        title: `${item?.name}`,
                        toolTip: [
                            {label:'Customer', value:item?.customer},
                            {label:'Creation year', value:item?.creationYear},
                            {label:'Project id', value:item?._id}
                        ],
                        color: 'white',
                        iconName: `Project_green`,
                        iconSize: 2.5,
                        timer: 500,
                        fixedSize: true,
                    }}
                >
                    <ProjectNode key={idx} idx={idx} project={item} projectId={project && project?._id} dispatch={dispatch} />
                </ToolTipWrapper>
                <ProtectedUsers protectedUsers={PROJECT_ADMIN}>
                    <ExecButton showLabel = {true} label={'Configure'} iconName={'Project_admin_configure'} func={()=>navigate(`/${ROUTES.PROJECTS}/${item._id}/${ROUTES.PROJECT_ADMIN_COFIGURATION}`)}/>
                </ProtectedUsers>
            </FlexCenter>
        )
    })


    return (
        <div className="grid-projects">
            <div className="grid-projects__header">
                <Title text={t('titles.projects')} size={'xl'} />
            </div>

            <div className="grid-projects__items">
                <ScrollY>
                    {projectsLoading ? (
                        <Full>
                            <RelativeCenter>
                                <Loader color="success" width={30} height={30} />
                            </RelativeCenter>
                        </Full>
                    ) : projectsData.length === 0 ? (
                        <ErrorNotification icon={<IconComponent size={3} iconName={'Empty list'} />} error={'Project list is empty'} text={''} textSize={1.3} />
                    ) : (
                        <SpacingCustom paddingTop={.7} paddingRight={.7}>
                            <ul className="projects">{createProjectButtons}</ul>
                        </SpacingCustom>
                    )}
                </ScrollY>
            </div>

            <div className="grid-projects__footer">
                <ExecButton
                    isDisabled={projectsData.length === 0 || !project?._id ? true : false}
                    label={t('buttons.submitProject')}
                    iconName={'Submit'}
                    func={()=>onSubmit()}
                />
            </div>
        </div>
    );
};
